import React, { useState } from "react";
import styled from "styled-components";

import { PlaylistPlayer } from "./PlayList";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PLAY_LIST = [
  {
    id: 149,
    type: "video",
    path: "http://134.209.99.53:3333/uploads/medias/2024-02-27-16-04-34gywcggdhl3lt455yjq.mp4",
    duration: 25,
    objectFit: "contain",
    name: "testv2.mp4",
    countItem: 1,
  },
  {
    id: 148,
    type: "image",
    path: "http://134.209.99.53:3333/uploads/medias/2024-02-21-10-57-35gywcggdhl3lsv9k2dg.jpg",
    duration: 5,
    objectFit: "contain",
    name: "test2.jpg",
    countItem: 2,
  },
  {
    id: 158,
    type: "video",
    path: "http://134.209.99.53:3333/uploads/medias/2024-02-29-09-54-15gywcggdhl3lt6mtfnn.mp4",
    duration: 5,
    objectFit: "contain",
    name: "Summer Cation Digital Poster1080x1920.mp4",
    countItem: 3,
  },
  {
    id: 151,
    type: "video",
    path: "http://134.209.99.53:3333/uploads/medias/2024-02-27-15-18-52gywcggdhl3lt43j6ta.mp4",
    duration: 5,
    objectFit: "contain",
    name: "Fl El Gold 1080X1920px 1.mp4",
    countItem: 4,
  },
];

export default () => {
  // const [onPlaying, setOnPlaying] = useState(false);
  return (
    <Container>
      {/* {!onPlaying && <button onClick={() => setOnPlaying(true)}>Play</button>}
      {onPlaying && <PlaylistPlayer playlist={PLAY_LIST} />} */}
      <PlaylistPlayer playlist={PLAY_LIST} />
    </Container>
  );
};
